import { isUndefined } from 'lodash';

import { type ClipDiscussionResponse } from '@air/api/types';

import { type ClipDiscussion } from '~/components/Annotations/shared/types';
import { getPageNumber, hasAnnotation } from '~/components/AnnotationsV2/shared/annotationUtils';
import { ASSET_MODAL_DISCUSSION_FILTERS } from '~/components/AssetModal/shared/context/DiscussionsPanelContext/discussionsPanelContextTypes';

/**
 * V2: Get annotated discussions using the annotations array instead of single annotation
 * This function filters discussions to only include those with valid annotations in the V2 format
 */
export const getAnnotatedDiscussions = ({
  discussions,
  timestamp,
  pageNumber,
  assetVersion,
  filter,
}: {
  discussions: ClipDiscussionResponse[];
  timestamp?: number;
  pageNumber: number;
  assetVersion?: number;
  filter: ASSET_MODAL_DISCUSSION_FILTERS;
}): ClipDiscussion[] =>
  discussions.filter((discussion): discussion is ClipDiscussion => {
    if (discussion.type !== 'clip') {
      return false;
    }

    if ((!isUndefined(timestamp) || discussion.timestamp) && discussion.timestamp !== timestamp) {
      return false;
    }

    // V2: Use annotations array for page number filtering
    if (pageNumber !== -1 && getPageNumber(discussion.annotations) !== pageNumber) {
      return false;
    }

    if (assetVersion && discussion.assetVersion !== assetVersion) {
      return false;
    }

    if (filter === ASSET_MODAL_DISCUSSION_FILTERS.OPENED && discussion.resolved) {
      return false;
    }

    if (filter === ASSET_MODAL_DISCUSSION_FILTERS.RESOLVED && !discussion.resolved) {
      return false;
    }

    // V2: Use annotations array to check if discussion has valid annotations
    return hasAnnotation(discussion);
  });
